import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import {
  ALLOW_APPLICANT_PHOTO_CHANGE,
  ALLOW_PROFILE_PHOTO_CHANGE,
  API_BASE_URL,
  CLIENT_TYPE,
  LANDING_THEME_PREVIEW,
  TRANSLATIONS_BASE_URL,
  formlyCore,
  FuseSplashScreenService,
  provideCore,
  provideCache,
  API_BASE_FILE_URL,
  API_BASE_PUBLIC_URL,
} from '@olymp/shared';
import { provideHttpClient } from '@angular/common/http';
import { environment } from '../environments/environment.development';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { ConfirmationService, MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    ConfirmationService,
    MessageService,
    FuseSplashScreenService,
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideCore(),
    provideCache({ version: environment.cacheVersion }),
    ...formlyCore,
    provideEnvironmentNgxMask(),
    provideHttpClient(),
    {
      provide: API_BASE_URL,
      useValue: environment.API_BASE_CLIENT_URL,
    },
    {
      provide: API_BASE_FILE_URL,
      useValue: environment.API_BASE_PUBLIC_URL,
    },
    {
      provide: API_BASE_PUBLIC_URL,
      useValue: environment.API_BASE_PUBLIC_URL,
    },
    {
      provide: TRANSLATIONS_BASE_URL,
      useValue: environment.API_BASE_CLIENT_URL,
    },
    {
      provide: CLIENT_TYPE,
      useValue: environment.type,
    },
    {
      provide: LANDING_THEME_PREVIEW,
      useValue: environment.landingThemePreview,
    },
    {
      provide: ALLOW_PROFILE_PHOTO_CHANGE,
      useValue: environment.allowProfilePhotoChange,
    },
    {
      provide: ALLOW_APPLICANT_PHOTO_CHANGE,
      useValue: environment.allowApplicantPhotoChange,
    },
  ],
};
